import { render } from "./ShiftCard.vue?vue&type=template&id=5516b47e&scoped=true"
import script from "./ShiftCard.vue?vue&type=script&lang=js"
export * from "./ShiftCard.vue?vue&type=script&lang=js"

import "./ShiftCard.vue?vue&type=style&index=0&id=5516b47e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/thadmin/thadmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5516b47e"]])

export default __exports__